<template>
  <div id="parkMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>场库管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{navigationMap[parkActiveName]}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="请选择客户">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-input placeholder="请输入场库名称"
                        v-model="bindQueryInput"
                        class="input-with-select">
                <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
              </el-input>
            </el-form-item>
            <el-form-item label="场库编号::">
              <el-input placeholder="请输入场库编号"
                        v-model="bindQueryfParkNo"
                        class="input-with-select">
                <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
              </el-input>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="bindRoadChecked">上海路政</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
              <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       @click="addSyncPark">新增场库</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="parkActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="场库列表"
                     name="parkList">
          <el-row>
            <el-table :data="parkList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="180"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkNo"
                               width="80"
                               label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               width="160"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fParkTypeName"
                               width="100"
                               label="场库类型">
              </el-table-column>
              <!-- <el-table-column prop="fLinkman"
                               width="140"
                               label="联系人">
              </el-table-column>
              <el-table-column prop="fLinkPhone"
                               width="140"
                               label="联系电话">
              </el-table-column> -->
              <el-table-column prop="fParkCount"
                               width="80"
                               align="right"
                               label="车位数量">
              </el-table-column>
              <el-table-column prop="fResCount"
                               width="80"
                               align="right"
                               label="保留数量">
              </el-table-column>
              <el-table-column prop="fAddress"
                               label="场库地址">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewPark(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             v-if="is_edit"
                             @click="editParkClient(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteParkClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_syn"
                             @click="synPark(scope.$index, scope.row,false)">上传</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synParkList">
          <el-row>
            <el-table :data="synParkList"
                      border
                      :row-class-name="tableRowClassName"
                      highlight-current-row
                      v-loading="loading"
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="200"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkNo"
                               width="80"
                               label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               width="200"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fParkTypeName"
                               width="100"
                               label="场库类型">
              </el-table-column>
              <el-table-column prop="fParkCount"
                               width="80"
                               align="right"
                               label="车位数量">
              </el-table-column>
              <el-table-column prop="fResCount"
                               width="80"
                               align="right"
                               label="保留数量">
              </el-table-column>
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewPark(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             v-if="is_edit"
                             @click="editParkClient(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteParkClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_syn"
                             @click="synPark(scope.$index, scope.row,true)">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <parkView ref="child"
              :parkActiveName="parkActiveName"
              :choiceCusts="choiceCusts"></parkView>
  </div>
</template>

<script>
import parkView from '../../components/parkView'
import * as user from '../../api/user'
import * as park from '../../api/park'
import { mapActions } from 'vuex'
export default {
  name: 'parkMain',
  components: { parkView },
  data () {
    return {
      navigationMap: {
        parkList: '场库列表',
        synParkList: '待同步'
      },
      export_loading: false,
      export_msg: '导出上海路政数据',
      loading: false,
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_export: false,
      parkActiveName: 'parkList',
      // regTypeList: [{ text: '公司代理', value: '0' }, { text: '用户注册', value: '1' }],
      choiceCusts: [],
      bindQueryfParkNo: '',
      bindRoadChecked: false,
      bindQueryInput: '',
      selCustID: '',
      parkList: [],
      synParkList: [],
      tableHeight: 0,
      pageSize: 20,
      pageIndex: 1,
      total: 0
      // wechatSer: false,
      // unionPay: false,
      // wechatCom: false,
      // alipay: false,
      // unionPayStatus: false,
      // wechatSerStatus: false,
      // wechatComStatus: false,
      // alipayStatus: false
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup'
    ]),
    tabClick () {
      this.pageIndex = 1
      this.total = 0
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    addSyncPark () {
      this.$refs.child.addSyncPark()
    },
    viewPark (row) {
      this.$refs.child.viewPark(row)
    },
    synPark (index, row, isSyn) {
      this.$refs.child.synPark(row, isSyn)
    },
    editParkClient (index, row) {
      this.$refs.child.editParkClient(row)
    },
    deleteParkClient (index, row) {
      this.$refs.child.deleteParkClient(row)
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      let param = {}
      param['fCustID'] = this.selCustID
      param['fParkName'] = this.bindQueryInput.trim()
      param['fParkNo'] = this.bindQueryfParkNo.trim()
      param['fIsChecked'] = this.bindRoadChecked
      param.parkActiveName = this.parkActiveName
      var isSyn = this.parkActiveName === 'synParkList'
      if (isSyn) {
        this.synParkList = []
      } else {
        this.parkList = []
      }
      park.exportParkSHRoadData(param).then(res => {
        this.export_loading = false
        this.export_msg = '导出上海路政数据'
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (isSyn) {
                this.fileDownload(data.Data, fileName + '_导出场库上海路政参数数据.xls')
              } else {
                this.fileDownload(data.Data, fileName + '_导出场库上海路政参数数据.xls')
              }
            } else {
              this.$message.error('提示：场库上海路政参数数据导出失败')
            }
          }
        }
      })
    },
    initData () {
      let param = {}
      param['fCustID'] = this.selCustID
      param['fParkName'] = this.bindQueryInput.trim()
      param['fParkNo'] = this.bindQueryfParkNo.trim()
      param['fIsChecked'] = this.bindRoadChecked
      param.pageSize = this.pageSize
      param.pageIndex = this.pageIndex
      param.parkActiveName = this.parkActiveName
      var isSyn = this.parkActiveName === 'synParkList'
      if (isSyn) {
        this.synParkList = []
      } else {
        this.parkList = []
      }
      this.loading = true
      park.getParkByCurrUser(param).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (isSyn) {
                this.synParkList = data.Data.data || []
              } else {
                this.parkList = data.Data.data || []
              }
              this.total = data.Data.count
              /*
              if (this.parkList && this.parkList.length > 0) {
                this.currentRow = this.parkList[0]
              } */
            } else {
              this.$message.error('提示：加载场库列表失败')
            }
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 21000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    // this.initData()
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
#parkMain .warning-row {
  color: chocolate;
}
</style>
<style scoped>
.parkMain_BaseInfo .el-select {
  width: 100%;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/park/parkMain.vue